import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from '@blueprintjs/core';
import { SvgNmrSum } from 'cheminfo-font';
import { Toolbar, useOnOff } from 'react-science/ui';
import { ChangeSumModalContents, } from './ChangeSumModalContents';
export default function ChangeSumModal(props) {
    const { disabled = false, currentSum, sumType, ...otherProps } = props;
    const [isOpenDialog, openDialog, closeDialog] = useOnOff(false);
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar.Item, { disabled: disabled, icon: _jsx(SvgNmrSum, {}), tooltip: currentSum
                    ? `Change ${sumType} sum (${currentSum.toFixed(2)})`
                    : `Change ${sumType} sum`, onClick: openDialog }), isOpenDialog && (_jsx(Dialog, { isOpen: true, onClose: closeDialog, style: { width: 500, height: 400 }, title: currentSum
                    ? `Set new ${sumType} sum (Current: ${currentSum.toFixed(2)})`
                    : `Set new ${sumType} Sum`, children: _jsx(ChangeSumModalContents, { ...otherProps, onClose: closeDialog }) }))] }));
}
